import styles from "./Badge.module.scss";
import cn from "classnames";

interface BadgeGroupProps {
  children?: React.ReactNode;
  vertical?: boolean;
}

export const BadgeGroup = ({
  children,
  vertical,
}: BadgeGroupProps) => {
  return (
    <div className={cn(
      styles.badgeGroup,
      vertical && styles.vertical,
    )}>
      {children}
    </div>
  );
};
